export default {"src":"/_next/static/media/room-category-all.f1575d76.svg","height":44,"width":73};